<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gc3FBg/tc-custom/9781504038263.jpg?1701327923156" alt="This image is the cover for the book Classic Children's Adventure Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Classic Children's Adventure Stories
      </h1>
      <p class="bookDescription body article font2">
        <b>Four timeless tales of adventure that have delighted generations of readers, young and old.</b><br/>  <br/><i>Peter Pan</i> is the enchanting story of a boy who wouldn’t grow up and the girl he promised to always remember. One magical night, two mischievous denizens of an island of the imagination visit Wendy Darling and her younger brothers in their London home. Peter Pan and Tinker Bell whisk the children away to Neverland to join the Lost Boys in their epic struggle against the evil Captain Hook.<br/>  <br/><i>The Wonderful Wizard of Oz </i>is the story that taught the world “there’s no place like home.” In a fairy tale so powerful that it seems every child is born knowing it, a tornado transports Dorothy Gale and her dog, Toto, from the flat prairies of Kansas to the marvelous Land of Oz. A fantastic journey soon follows as Dorothy, the Scarecrow, the Tin Woodman, and the Cowardly Lion travel the Yellow Brick Road to the Emerald City, where they hope all their dreams will come true.<br/>  <br/><i>Alice’s Adventures in Wonderland </i>is an irresistible ode to the joys of childhood. An immediate sensation when it was first published one hundred fifty years ago, Lewis Carroll’s groundbreaking fantasy novel takes readers on a incredible journey from a drowsy riverbank in England to an extraordinary world populated with unforgettable characters including the anxious White Rabbit, the Mad Hatter, the grinning Cheshire Cat, and the notorious Queen of Hearts.<br/>  <br/><i>The Swiss Family Robinson </i>is the beloved story of a family marooned on a desert island. Left behind by the crew and other passengers of their wrecked ship, four brothers and their steadfast parents build a home in the jungle wilderness, complete with livestock, a small farm, and a sturdy tree house for shelter. In no time, the Robinson family learns how much can be accomplished through hard work, cooperation, curiosity, and perseverance.<br/>  <br/> This ebook has been professionally proofread to ensure accuracy and readability on all devices.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. M. Barrie, L. Frank Baum, Lewis Carroll, Johann David Wyss
      </h2>
      
      <p class="authorDescription body article">J. M. Barrie (1860&ndash;1937) was a Scottish author best known for creating <I>Peter Pan</I>. Born in the small town of Kirriemuir, Barrie was the ninth of ten children. When he was six years old, his older brother David died just before turning fourteen. Both Barrie and his mother took comfort in the idea that David would remain a boy forever, never growing old. Barrie never had children of his own, but was the legal guardian of five brothers, known collectively as the Davies boys, who are widely recognized as the inspiration for the character of Peter Pan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c91b72b